import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CheckoutDataState } from "../../../features/view/private/chekout/CheckoutTypes";
import {
  getDeliveryInfoList,
  paymentVerification,
  getPastOrderDataDetails,
  paymentCheckout,
  getCouponList,
  getAddressChange,
  getBillDetails,
  paymentVerify,
  paymentCustomerOrderCheckout,
  getWhatsapCheck,
} from "./CheckoutApi";

const initialState: CheckoutDataState = {
  stepperActive: "account",
  isPayButtonDisabled: true,
  addressSelectedtype: "",
  isInfoButtonDisabled: true,
  deliveryinfoList: {
    data: [],
    loader: false,
    pickup: "false",
    shopDetails: {
      shop_name: "",
      shop_phone: "",
      shop_location: "",
      latitude: "",
      longitude: "",
    },
  },
  selectedAddressId: "",
  selectedDeliverySlot: "",
  selectedDeliveryType: "",
  selectedDeliveryDate: "",
  opt_in: true,
  // pickupAvailable: "",
  // shopDetails: "",
  orderInfoData: {
    data: {
      order_status: "",
      order_ID: "",
      shop_name: "",
      shop_location: "",
      shop_contact: "",
      delivery_slot_date: "",
      delivery_slot_time: "",
      created_date: "",
      taxes_and_charges: 0.0,
      delivery_charges: 0.0,
      grand_total: 0.0,
      sub_total: 0.0,
    },
    loader: false,
  },
  confirmedOrder: {},
  couponList: { data: [], loader: false },
  billDetails: { data: [], loader: false },
};

export const getDeliveryInfoListAsync = createAsyncThunk(
  "checkout/delivery/info",
  async () => {
    const response = await getDeliveryInfoList();
    return response;
  }
);

export const paymentCheckoutAsync = createAsyncThunk(
  "orders/checkout",
  async (payload: any) => {
    const response = await paymentCheckout(payload);
    return response;
  }
);

export const paymentCustomOrderCheckoutAsync = createAsyncThunk(
  "orders/custom_order_checkout/",
  async (payload: any) => {
    const response = await paymentCustomerOrderCheckout(payload);
    return response;
  }
);

export const paymentVerifyAsync = createAsyncThunk(
  "orders/double/verify/",
  async (payload: any) => {
    const response = await paymentVerify(payload);
    return response;
  }
);
export const paymentVerificationAsync = createAsyncThunk(
  "orders/verifypayment/",
  async (payload: any) => {
    const response = await paymentVerification(payload);
    return response;
  }
);

export const getPastOrderDataDetailsAsync = createAsyncThunk(
  "orders/past-orders/",
  async (uuid: any) => {
    const response = await getPastOrderDataDetails(uuid);
    return response;
  }
);

export const getCouponListAsync = createAsyncThunk(
  "orders/coupons/",
  async () => {
    const response = await getCouponList();
    return response;
  }
);

export const getAddressChangeAsync = createAsyncThunk(
  "orders/address-change/",
  async (payload: any) => {
    const response = await getAddressChange(payload);
    return response;
  }
);
export const getBillDetailsAsync = createAsyncThunk(
  "orders/download-bill/",
  async (orderid: any) => {
    const response = await getBillDetails(orderid);
    return response;
  }
);

export const getWhatsapCheckAsync = createAsyncThunk(
  "accounts/check-opt-in/",
  async () => {
    const response = await getWhatsapCheck();
    return response;
  }
);
export const CheckoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setStepperActiveMenu: (state, action: any) => {
      state.stepperActive = action.payload;
    },
    setAddressType: (state, action: PayloadAction<string>) => {
      state.addressSelectedtype = action.payload;
    },
    setPayButtonDisabled(state, action) {
      state.isPayButtonDisabled = action.payload;
    },
    setInfoButtonDisabled(state, action) {
      state.isInfoButtonDisabled = action.payload;
    },
    selectedAddressId(state, action) {
      state.selectedAddressId = action.payload;
    },
    selectedDeliverySlot(state, action) {
      state.selectedDeliverySlot = action.payload;
    },
    selectedDeliveryType(state, action) {
      state.selectedDeliveryType = action.payload;
    },
    orderInfoData(state, action) {
      state.orderInfoData = action.payload;
    },
    selectedDeliveryDate(state, action) {
      state.selectedDeliveryDate = action.payload;
    },
    setOrderDetails: (state, action: PayloadAction<string>) => {
      state.confirmedOrder = action.payload;
    },
    setOptIn: (state, action: PayloadAction<boolean>) => {
      state.opt_in = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getDeliveryInfoListAsync.pending, (state) => {
        state.deliveryinfoList.loader = true;
      })
      .addCase(getDeliveryInfoListAsync.fulfilled, (state, action: any) => {
        state.deliveryinfoList.loader = false;
        state.deliveryinfoList.data = action?.payload?.data?.data || [];
        state.deliveryinfoList.pickup = action?.payload?.data?.pickup_available;
        state.deliveryinfoList.shopDetails =
          action?.payload?.data?.shop_details;
      })
      .addCase(getDeliveryInfoListAsync.rejected, (state) => {
        state.deliveryinfoList.loader = false;
      })
      .addCase(paymentCheckoutAsync.pending, (state) => {
        state.orderInfoData.loader = true;
      })
      .addCase(paymentCheckoutAsync.fulfilled, (state, action: any) => {
        state.orderInfoData.loader = false;
        state.orderInfoData.data = action?.payload?.data?.data || [];
      })
      .addCase(paymentCheckoutAsync.rejected, (state) => {
        state.orderInfoData.loader = false;
      })
      .addCase(getPastOrderDataDetailsAsync.pending, (state) => {
        state.orderInfoData.loader = true;
      })
      .addCase(getPastOrderDataDetailsAsync.fulfilled, (state, action: any) => {
        state.orderInfoData.loader = false;
        state.orderInfoData.data = action?.payload?.data?.order_details || [];
      })
      .addCase(getPastOrderDataDetailsAsync.rejected, (state) => {
        state.orderInfoData.loader = false;
      })
      .addCase(getCouponListAsync.pending, (state) => {
        state.orderInfoData.loader = true;
      })
      .addCase(getCouponListAsync.fulfilled, (state, action: any) => {
        state.couponList.loader = false;
        state.couponList.data = action?.payload?.data?.coupons || [];
      })
      .addCase(getCouponListAsync.rejected, (state) => {
        state.couponList.loader = false;
      })
      .addCase(getBillDetailsAsync.pending, (state) => {
        state.billDetails.loader = true;
      })
      .addCase(getBillDetailsAsync.fulfilled, (state, action: any) => {
        state.billDetails.data = action?.payload?.data || [];
      })
      .addCase(getBillDetailsAsync.rejected, (state) => {
        state.billDetails.loader = false;
      })
      .addCase(getWhatsapCheckAsync.fulfilled, (state, action: any) => {
        state.opt_in = action.payload?.data?.opt_in;
      });
  },
});
export const {
  setStepperActiveMenu,
  setInfoButtonDisabled,
  setPayButtonDisabled,
  selectedAddressId,
  selectedDeliverySlot,
  selectedDeliveryType,
  selectedDeliveryDate,
  orderInfoData,
  setOrderDetails,
  setOptIn,
} = CheckoutSlice.actions;

export default CheckoutSlice.reducer;
